import { Pipe, PipeTransform } from '@angular/core';
import { PublicService } from './../public.service';

@Pipe({
  name: 'decodeHtml'
})
export class decodeHtmlPipe implements PipeTransform {

  constructor(public publicService: PublicService) { }

  transform(value: any, args?: any): any {
    return this.publicService.decodeHtml(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/public/pipe/decodeHtml.pipe.ts